import { fetchBasicGetJson, fetchBasicUrlGetJson, fetchGetJson } from '@/script/common';

export default {
    getBalanceData: () => fetchBasicGetJson(`/Payment/GetBalance`),
    getPersonBalanceDetails: (code, date) =>
        fetchBasicUrlGetJson(
            '/Mio/GetPersonBalanceDetails',
            { data: { personCode: code, date } }
        ),
    getOrganizationBalanceDetails: (code, date) =>
        fetchBasicUrlGetJson(
            '/Mio/GetOrganizationBalanceDetails',
            { data: { organizationCode: code, date } }
        ),
    getTerminalConfig: () =>
        fetchGetJson('/Payment/TerminalConfig', { }, { useBlock: false })
};
